// src/v-permission.js
export default {
  mounted(el, binding) {
    const { value: expectedRoles, instance } = binding;
    const store = instance.$store;

    // Si existe $canView (del plugin), lo usamos.
    const canView =
      typeof instance.$canView === 'function'
        ? instance.$canView
        : () => {
            const userRole = store?.state?.role;
            if (!userRole || !Array.isArray(expectedRoles)) return false;
            return expectedRoles.includes(userRole);
          };

    const roles = Array.isArray(expectedRoles) ? expectedRoles : [];

    const applyVisibility = () => {
      const allowed = roles.length ? canView(...roles) : true;
      el.style.display = allowed ? '' : 'none';
    };

    // Validación inicial
    applyVisibility();

    // Reaccionar cuando cambie el rol en el store
    if (store && typeof store.subscribe === 'function') {
      store.subscribe((mutation) => {
        if (mutation.type === 'setRole' || mutation.type === 'clearRole') {
          applyVisibility();
        }
      });
    }
  },
};
